"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BenchmarkRenderable = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function DefaultLine(props) {
  return _react.default.createElement("line", (0, _extends2.default)({
    stroke: "inherit"
  }, props.lineProps));
}

function DefaultText(props) {
  return _react.default.createElement("text", (0, _extends2.default)({
    fontSize: 12,
    children: props.children,
    stroke: "none"
  }, props.textProps));
}
/**
 *
 * @component
 *
 * Benchmark renders a straight line on an x|y axis with a label
 *
 * @example
 *
 * <BenchmarkRenderable
 *     dimension="x"
 *     location={20}
 *     label="Foo"
 * />
 *
 */


var BenchmarkRenderable =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(BenchmarkRenderable, _React$PureComponent);

  function BenchmarkRenderable() {
    (0, _classCallCheck2.default)(this, BenchmarkRenderable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BenchmarkRenderable).apply(this, arguments));
  }

  (0, _createClass2.default)(BenchmarkRenderable, [{
    key: "drawText",
    //
    // Text
    value: function drawText() {
      var _this$props = this.props,
          Text = _this$props.text,
          location = _this$props.location,
          label = _this$props.label,
          dimension = _this$props.dimension,
          labelOffset = _this$props.labelOffset;

      var _labelOffset = (0, _slicedToArray2.default)(labelOffset, 2),
          offsetX = _labelOffset[0],
          offsetY = _labelOffset[1];

      var _this$getPointPositio = this.getPointPosition(dimension, location),
          _this$getPointPositio2 = (0, _slicedToArray2.default)(_this$getPointPositio, 2),
          x = _this$getPointPositio2[0],
          y = _this$getPointPositio2[1];

      var textProps = {
        x: x + offsetX,
        y: y + offsetY,
        textProps: (0, _objectSpread2.default)({
          x: x + offsetX,
          y: y + offsetY,
          transform: dimension === 'x' ? "rotate(90, ".concat(x, ", ").concat(y, ")") : null
        }, this.props.textProps)
      };
      return _react.default.createElement(Text, textProps, label);
    } //
    // Line

  }, {
    key: "getLengthProp",
    value: function getLengthProp(dimension) {
      return dimension === 'y' ? 'width' : 'height';
    }
  }, {
    key: "getPointPosition",
    value: function getPointPosition(dimension, location) {
      var scale = this.props["".concat(dimension, "Scale")];
      var value = scale(location);
      var height = this.props.height;
      var width = this.props.width;

      if (dimension === 'x') {
        return [value, 0, value, height];
      } else {
        return [0, height - value, width, height - value];
      }
    }
  }, {
    key: "drawLine",
    value: function drawLine() {
      var _this$props2 = this.props,
          Line = _this$props2.line,
          location = _this$props2.location,
          dimension = _this$props2.dimension;

      var _this$getPointPositio3 = this.getPointPosition(dimension, location),
          _this$getPointPositio4 = (0, _slicedToArray2.default)(_this$getPointPositio3, 4),
          x1 = _this$getPointPositio4[0],
          y1 = _this$getPointPositio4[1],
          x2 = _this$getPointPositio4[2],
          y2 = _this$getPointPositio4[3];

      var lineProps = {
        x: x1,
        y: y1,
        lineProps: (0, _objectSpread2.default)({
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2
        }, this.props.lineProps)
      };
      return _react.default.createElement(Line, lineProps);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("g", null, this.props.label && this.drawText(), this.drawLine());
    }
  }]);
  return BenchmarkRenderable;
}(_react.default.PureComponent);

exports.BenchmarkRenderable = BenchmarkRenderable;
(0, _defineProperty2.default)(BenchmarkRenderable, "defaultProps", {
  textPosition: 'top',
  dimension: 'y',
  line: DefaultLine,
  lineProps: {},
  labelOffset: [0, 0],
  text: DefaultText,
  textProps: {}
});
(0, _defineProperty2.default)(BenchmarkRenderable, "propTypes", {
  /** {'top'|'right'|'bottom'|'left'} The position of the label */
  textPosition: _propTypes.default.oneOf(['top', 'bottom']),

  /** {'x'|'y'} The scale to base the benchmark on */
  dimension: _propTypes.default.oneOf(['x', 'y']),

  /** Domain value of opposite scale at which to render the axis */
  location: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.instanceOf(Date)]).isRequired,

  /** Label next to the line */
  label: _propTypes.default.string,

  /** xy tuple to reposition the label away from the line */
  labelOffset: _propTypes.default.arrayOf(_propTypes.default.number),

  /** Custom line renderer */
  line: _propTypes.default.func,

  /** {Object} An object of props that are passed to the axis line - the line that sits against the chart edge. */
  lineProps: _propTypes.default.object,

  /** Custom text renderer */
  text: _propTypes.default.func,

  /** {Object} An object of props that are passed to the each text node */
  textProps: _propTypes.default.object,

  /** {Scale} The [d3-scale](https://github.com/d3/d3-scale) for the axis */
  xScale: _propTypes.default.func,

  /** {Scale} The [d3-scale](https://github.com/d3/d3-scale) for the axis */
  yScale: _propTypes.default.func,

  /** The width of the axis */
  width: _propTypes.default.number.isRequired,

  /** The height of the axis */
  height: _propTypes.default.number.isRequired
});

var Benchmark =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Benchmark, _React$Component);

  function Benchmark() {
    (0, _classCallCheck2.default)(this, Benchmark);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Benchmark).apply(this, arguments));
  }

  (0, _createClass2.default)(Benchmark, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(BenchmarkRenderable, this.props);
    }
  }]);
  return Benchmark;
}(_react.default.Component);

exports.default = Benchmark;